import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import ComponentReport from "./ComponentReport";

export default function ReportCampaign() {
  return (
    <>
      <Sidebar activeItem="report-campaigns" />
      <div className="content-wrapper">
        <TitleBar title="گزارش کمپین ها" />

        <section className="content pt-5" id="report-content">
          <div className="container-fluid">
            <div className="row">
              <ComponentReport />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
